import {
  FETCH_LANGUAGES,
  SET_LANGUAGES,
  SAVE_LANGUAGE_REQUEST,
  SAVE_LANGUAGE_SUCCESS,
  SAVE_LANGUAGE_FAILURE,
  LANGUAGE_SET_FILTER,
  LANGUAGE_MODAL_OPEN,
  LANGUAGE_MODAL_CLOSE,
  CourseLanguage,
} from './actions';

export interface CourseLanguageManagerState {
  list: CourseLanguage[];
  loading: boolean;
  saving: boolean;
  error?: string;
  filterName: string;
  modalOpen: boolean;
  editing: CourseLanguage | null;
}

const initialState: CourseLanguageManagerState = {
  list: [],
  loading: false,
  saving: false,
  error: undefined,
  filterName: '',
  modalOpen: false,
  editing: null,
};

export default function courseLanguageManagerReducer(
  state: CourseLanguageManagerState = initialState,
  action: any
): CourseLanguageManagerState {
  switch (action.type) {
    case FETCH_LANGUAGES:
      return { ...state, loading: true, error: undefined };

    case SET_LANGUAGES:
      return { ...state, loading: false, list: action.payload ?? [] };

    case SAVE_LANGUAGE_REQUEST:
      return { ...state, saving: true, error: undefined };

    case SAVE_LANGUAGE_SUCCESS:
      return { ...state, saving: false };

    case SAVE_LANGUAGE_FAILURE:
      return { ...state, saving: false, error: action.error };

    case LANGUAGE_SET_FILTER:
      return { ...state, filterName: action.payload ?? '' };

    case LANGUAGE_MODAL_OPEN:
      return { ...state, modalOpen: true, editing: action.payload ?? null };

    case LANGUAGE_MODAL_CLOSE:
      return { ...state, modalOpen: false, editing: null };

    default:
      return state;
  }
}